import {
  ALL_DATA_MANAGEMENT_MNEMONICS,
  KICK_DETECTION_DATA_MANAGEMENT_MNEMONICS,
  KICK_PREDICTION_DATA_MANAGEMENT_MNEMONICS,
  STUCK_PREDICTION_DATA_MANAGEMENT_MNEMONICS,
} from 'constants/mnemonicsMapping';
import { useIsDevPO } from 'hooks/useItsDevPo';
import React from 'react';
import { useIntl } from 'react-intl';
import { DepthMnemonicMappingDTO } from 'types/mnemonicsMapping';

import styles from './MnemonicMappingTable.module.scss';
import MnemonicMappingIndicator from '../MnemonicMappingIndicator';
export interface Props {
  liveMnemonics?: Record<string, string>;
  mnemonicsDepthData?: DepthMnemonicMappingDTO;
  isFlowOutAVNA?: boolean;
  isFlowOutPCNA?: boolean;
  isFlowInBstNA: boolean;
  isLive?: boolean;
  isDatasetWellNotASensorWell?: boolean;
}

const MnemonicMappingTable: React.FC<Props> = props => {
  const intl = useIntl();
  const isDevPO = useIsDevPO();

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.columnTitle}>
            {intl.formatMessage({ id: 'dataManagement.dataQuality.table.mappingTable.feature' })}
          </th>
          <th className={styles.columnTitle}>
            {intl.formatMessage({ id: 'dataManagement.dataQuality.table.mappingTable.stuck' })}
          </th>
          <th className={styles.columnTitle}>
            {intl.formatMessage({ id: 'dataManagement.dataQuality.table.mappingTable.kickP' })}
          </th>
          {isDevPO && (
            <th className={styles.columnTitle}>
              {intl.formatMessage({ id: 'dataManagement.dataQuality.table.mappingTable.kickD' })}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {ALL_DATA_MANAGEMENT_MNEMONICS.map(mnemonic => (
          <tr key={mnemonic}>
            <td className={styles.text} valign="middle">
              {intl.formatMessage({
                id: `dataManagement.dataQuality.table.mappingTable.${mnemonic}`,
              })}
            </td>
            <td>
              <MnemonicMappingIndicator
                mnemonic={mnemonic}
                scopeMnemonics={STUCK_PREDICTION_DATA_MANAGEMENT_MNEMONICS}
                {...props}
              />
            </td>
            <td>
              <MnemonicMappingIndicator
                mnemonic={mnemonic}
                scopeMnemonics={KICK_PREDICTION_DATA_MANAGEMENT_MNEMONICS}
                {...props}
              />
            </td>
            {isDevPO && (
              <td>
                <MnemonicMappingIndicator
                  isKDMapping
                  mnemonic={mnemonic}
                  scopeMnemonics={KICK_DETECTION_DATA_MANAGEMENT_MNEMONICS}
                  {...props}
                />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default MnemonicMappingTable;
